/**
 * Mini Collections Carousel
 * Initializes Swiper carousel for mini collection cards on mobile devices
 * Shows second slide initially with 10% peek of first and third slides
 */

if (document.querySelector('#mini-collections-carousel')) {
  const miniCollectionsSwiper = new Swiper('#mini-collections-carousel', {
    // Slides configuration - full width with side peek
    slidesPerView: 1.2,
    spaceBetween: 16,
    centeredSlides: true,

    // Start at second slide (index 1)
    initialSlide: 1,

    // Pagination
    pagination: {
      el: '#mini-collections-pagination',
      clickable: true,
      dynamicBullets: false,
    },

    // Touch settings
    touchRatio: 1,
    touchAngle: 45,
    grabCursor: true,

    // Performance
    watchSlidesProgress: true,
    watchSlidesVisibility: true,

    // Accessibility
    a11y: {
      prevSlideMessage: 'Coleção anterior',
      nextSlideMessage: 'Próxima coleção',
      firstSlideMessage: 'Esta é a primeira coleção',
      lastSlideMessage: 'Esta é a última coleção',
      paginationBulletMessage: 'Ir para coleção {{index}}'
    },

    // Loop configuration
    loop: false,

    // Breakpoints - disable on larger screens
    breakpoints: {
      // When window width is >= 750px, disable swiper
      750: {
        enabled: false
      }
    }
  });
}
